export class InsertionOrder {
  name: string;
  state: string;
  budget_type: "revenue" | "impression" | "flexible";
  type: "regular" | "private_deal";
  budget_intervals: Array<BudgetInterval>;
  caps: Cap | null;
  io_deal_type: string;
  inventory_lists: Array<any>;

  constructor() {
    this.caps = new Cap();
    this.name = "";
    this.budget_type = "revenue";
    this.state = "inactive";
    this.io_deal_type = "open_rtb";
    this.budget_intervals = [];
    this.inventory_lists = [];
    this.type = "regular";
  }
}

export const enum IoDefaults {
  IO_MIN_FLIGHT_BUDGET = 50,
  IO_MAX_FLIGHT_BUDGET = 100000,
}

export class Cap {
  imps_cap_per_day: number;
  imps_cap_per_week: number;
  imps_cap_per_hour: number;
  imps_cap_lifetime: number;
  imps_cap_per_month: number;
  minutes_per_imp: number;

  constructor() {}
}

export class BudgetInterval {
  start_date;
  end_date;
  revenue_budget: number | null;
  imps_budget: number | null;
  disabled_start_date: boolean;
  disabled_end_date: boolean;

  constructor() {
    this.disabled_start_date = false;
    this.disabled_end_date = false;
  }
}

export let ioDealtypeFilter = [
  { value: "all", label: "All" },
  { value: "pg_others", label: "PG Deal" },
  { value: "pg_netflix", label: "Netflix PG" },
  { value: "pmp_others", label: "PMP Deal" },
  { value: "pmp_netflix", label: "PMP Netflix" },
  { value: "open_rtb", label: "Open RTB" },
];

export let ioDealTypeMapping: { [key: string]: string } = {
  pg_others: "PG Deal",
  pg_netflix: "Netflix PG",
  pmp_others: "PMP Deal",
  pmp_netflix: "PMP Netflix",
  open_rtb: "Open RTB",
};

export let dealTypes = [
  {
    value: "pg_netflix",
    label: "Netflix PG",
    tooltip: "Select this option if you want to target Netflix PG deals.",
  },
  {
    value: "pg_others",
    label: "PG Deal",
    tooltip:
      "Select this option if you want to target Programmatic Guaranteed Deals.",
  },
  {
    value: "pmp_others",
    label: "PMP Deal",
    tooltip:
      "Select this option if you want to target Private Market Place or Private Auction Deals. Also Select Yes for Private Deals if you have publisher negotiated deals to use in this Insertion Order. Else select No.",
  },
  {
    value: "pmp_netflix",
    label: "PMP Netflix",
    tooltip:
      "Select this option if you want to target Private Market Place or Private Auction Netflix Deals. Also Select Yes for Private Deals if you have publisher negotiated deals to use in this Insertion Order. Else select No.",
  },
  {
    value: "open_rtb",
    label: "Open RTB",
    tooltip: "Select if you want to target auction based inventory.",
  },
];
